/**
 * An event for scrolling an element into view within.
 */
export const PRIZM_SCROLL_INTO_VIEW = 'prizm-scroll-into-view';

/**
 * An event to notify that
 * it should control a nested element.
 */
export const PRIZM_SCROLLABLE = 'prizm-scrollable';
